import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { QuestionService } from "../api";

export const actionCreateQuestion = createAsyncThunk(
  "question/create-question",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QuestionService.doCreateQuestion(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);
export const actionCreateAnswerQuestion = createAsyncThunk(
  "question/create-answer-question",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QuestionService.doCreateAnswerQuestion(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);
export const actionGetAllQuestion = createAsyncThunk(
  "question/get-all-question",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QuestionService.doGetAllQuestion(data);

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);
export const actionGetQuestionPending = createAsyncThunk(
  "question/get-question-pending",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QuestionService.doGetQuestionPending(data);

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);
export const actionGetDetailQuestion = createAsyncThunk(
  "question/detail-question",
  async (id, { rejectWithValue }) => {
    try {
      const res = await QuestionService.doGetDetailQuestion(id);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);
export const actionGetListQuestionDoctor = createAsyncThunk(
  "question/list-question-doctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QuestionService.doGetListQuestionDoctor(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);
export const actionGetListQuestionUser = createAsyncThunk(
  "question/list-question-user",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QuestionService.doGetListQuestionUser(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const questionSlice = createSlice({
  name: "question",
  initialState: {
    createQuestion: {
      loading: false,
      data: null,
      error: "",
    },
    createAnswerQuestion: {
      loading: false,
      data: null,
      error: "",
    },
    allQuestion: {
      loading: false,
      data: null,
      error: "",
    },
    questionPending: {
      loading: false,
      data: null,
      error: "",
    },
    detailQuestion: {
      loading: false,
      data: null,
      error: "",
    },
    listQuestionDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    listQuestionUser: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // CreateQuestion
      .addCase(actionCreateQuestion.pending, (state) => {
        state.createQuestion.loading = true;
      })
      .addCase(actionCreateQuestion.fulfilled, (state, action) => {
        state.createQuestion.loading = false;
        state.createQuestion.data = action.payload;
      })
      .addCase(actionCreateQuestion.rejected, (state, action) => {
        state.createQuestion.loading = false;
        state.createQuestion.data = action.payload;
        state.createQuestion.error =
          action.error.message || "Something went wrong";
      })
      // CreateAnswerQuestion
      .addCase(actionCreateAnswerQuestion.pending, (state) => {
        state.createAnswerQuestion.loading = true;
      })
      .addCase(actionCreateAnswerQuestion.fulfilled, (state, action) => {
        state.createAnswerQuestion.loading = false;
        state.createAnswerQuestion.data = action.payload;
      })
      .addCase(actionCreateAnswerQuestion.rejected, (state, action) => {
        state.createAnswerQuestion.loading = false;
        state.createAnswerQuestion.data = action.payload;
        state.createAnswerQuestion.error =
          action.error.message || "Something went wrong";
      })
      // allQuestion
      .addCase(actionGetAllQuestion.pending, (state) => {
        state.allQuestion.loading = true;
      })
      .addCase(actionGetAllQuestion.fulfilled, (state, action) => {
        state.allQuestion.loading = false;
        state.allQuestion.data = action.payload;
      })
      .addCase(actionGetAllQuestion.rejected, (state, action) => {
        state.allQuestion.loading = false;
        state.allQuestion.data = action.payload;
        state.allQuestion.error =
          action.error.message || "Something went wrong";
      })
      // doGetQuestionPending
      .addCase(actionGetQuestionPending.pending, (state) => {
        state.questionPending.loading = true;
      })
      .addCase(actionGetQuestionPending.fulfilled, (state, action) => {
        state.questionPending.loading = false;
        state.questionPending.data = action.payload;
      })
      .addCase(actionGetQuestionPending.rejected, (state, action) => {
        state.questionPending.loading = false;
        state.questionPending.data = action.payload;
        state.questionPending.error =
          action.error.message || "Something went wrong";
      })
      // doGetDetailQuestion
      .addCase(actionGetDetailQuestion.pending, (state) => {
        state.detailQuestion.loading = true;
      })
      .addCase(actionGetDetailQuestion.fulfilled, (state, action) => {
        state.detailQuestion.loading = false;
        state.detailQuestion.data = action.payload;
      })
      .addCase(actionGetDetailQuestion.rejected, (state, action) => {
        state.detailQuestion.loading = false;
        state.detailQuestion.data = action.payload;
        state.detailQuestion.error =
          action.error.message || "Something went wrong";
      })
      // doGetListQuestionDoctor
      .addCase(actionGetListQuestionDoctor.pending, (state) => {
        state.listQuestionDoctor.loading = true;
      })
      .addCase(actionGetListQuestionDoctor.fulfilled, (state, action) => {
        state.listQuestionDoctor.loading = false;
        state.listQuestionDoctor.data = action.payload;
      })
      .addCase(actionGetListQuestionDoctor.rejected, (state, action) => {
        state.listQuestionDoctor.loading = false;
        state.listQuestionDoctor.data = action.payload;
        state.listQuestionDoctor.error =
          action.error.message || "Something went wrong";
      })
      // doGetListQuestionUser
      .addCase(actionGetListQuestionUser.pending, (state) => {
        state.listQuestionUser.loading = true;
      })
      .addCase(actionGetListQuestionUser.fulfilled, (state, action) => {
        state.listQuestionUser.loading = false;
        state.listQuestionUser.data = action.payload;
      })
      .addCase(actionGetListQuestionUser.rejected, (state, action) => {
        state.listQuestionUser.loading = false;
        state.listQuestionUser.data = action.payload;
        state.listQuestionUser.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default questionSlice.reducer;
export const { actions, reducer } = questionSlice;
